
import { defineComponent } from 'vue'
import InterOral from '@/components/ja/presentation/InterOral.vue'
import InterPoster from '@/components/ja/presentation/InterPoster.vue'
import DomesticOral from '@/components/ja/presentation/DomesticOral.vue'
import DomesticPoster from '@/components/ja/presentation/DomesticPoster.vue'
import ExtSeminar from '@/components/ja/presentation/ExtSeminar.vue'

export default defineComponent({
  name: 'PresentationJa',
  components: {
    InterOral,
    InterPoster,
    DomesticOral,
    DomesticPoster,
    ExtSeminar
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'presentation'
    }
  }
})
